import { baseApi } from "./apiConfig";
// ! ********************* CONTACT INFORMATION API **************** /////

export const getUserInfoAndDetail = async () => {
  try {
    const response = await baseApi.get(
      `/portal/user/getUserInfoAndAddressDetails`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getUserInfoAndDetail", error);
    throw error;
  }
};

export const getBuyersPremiumDetail = ({ listingId, bidAmount }) => {
  return baseApi
    .get(`/portal/buyerPremium/${listingId}/${bidAmount}`)
    .then((response) => {
      // log("getBidAmountDetail", listingId, bidAmount, response);
      return response.data;
    })
    .catch((e) => {
      // log("error:", e);
    });
};

export const isAvailableBackUpBidAmount = ({ listingId, bidAmount }) => {
  let amnt = bidAmount;

  if (amnt?.length === 0 || isNaN(amnt) || !amnt) {
    amnt = 0;
  }

  return baseApi
    .get(`/portal/v2.0/getAvailableBackUpBidAmount/${listingId}/${amnt}`)
    .then((response) => {
      return response.data;
    })
    .catch((e) => {
      console.log("error:", e);
    });
};

export const getInitiatePayment = async (payload) => {
  try {
    const response = await baseApi.post(
      `/portal/bid-participation/initiatePayment`,
      payload
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getInitiatePayment", error);
    throw error;
  }
};
// /portal/bid-participation/updatePaymentStatus/0aa8d9c4-9749-4e4c-9813-3898b7cd43e0
export const updatePaymentStatus = async (paymentReferenceNumber) => {
  try {
    const response = await baseApi.post(
      `/portal/bid-participation/updatePaymentStatus/${paymentReferenceNumber}`,
      {}
    );
    return response;
  } catch (error) {
    console.log("Error while fetching updatePaymentStatus", error);
    throw error;
  }
};
// ! ********************* BID DEPOSIT HOLD API **************** /////

export const getBidPageDetail = async (payload) => {
  try {
    const response = await baseApi.post(
      `/portal/v2.0/getBidPageDetail`,
      payload
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getBidPageDetail", error);
    throw error;
  }
};
// add logic if not !cash && bidDetails.repeatBid then replace cash with mortgage
export const getBidAmountDetail = async (id, data) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/getBidAmountDetail/${id}/CASH/${data}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getBidAmountDetail", error);
    throw error;
  }
};
//buy-bid-participation-feature-web-qe.internal.hubzu.com/portal/v2.0/getBidAmountDetail/0001641462238489AUCN1/CASH/308999

//buy-bid-participation-feature-web-qe.internal.hubzu.com/portal/v2.0/getBidAmountDetail/0001641374665424AUCN1/CASH/94000
export const getBidDepositBuyerInfo = async (id, data) => {
  try {
    const response = await baseApi.get(
      `/portal/get-cif-details/${id}?buyerEmail=${data}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getbidDepositHold", error);
    throw error;
  }
};

export const getBidDepositBuyerAmountInfo = async (id, data) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/getBidAmountDetail/${id}/CASH/${data}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getBidDepositBuyerAmountInfo", error);
    throw error;
  }
};

export const getBidDepositContigencyCash = async (id, data) => {
  try {
    const response = await baseApi.get(
      `/portal/api/bidContigency/${id}/CASH/${data}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getBidDepositContigencyCash", error);
    throw error;
  }
};

export const getBidDepositContigencyMortgage = async (id, data) => {
  try {
    const response = await baseApi.get(
      `/portal/api/bidContigency/${id}/MORTGAGE/${data}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getBidDepositContigencyMortgage", error);
    throw error;
  }
};

export const getFinancingRehabLoan = async (id, value, cash) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/getBidAmountDetail/${id}/${value}/${cash}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getFinancingRehabLoan", error);
    throw error;
  }
};
export const getFinancingConventionalFinancing = async (id, value, cash) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/getBidAmountDetail/${id}/${value}/${cash}`
    );
    return response;
  } catch (error) {
    console.log(
      "Error while fetching getFinancingConventionalFinancing",
      error
    );
    throw error;
  }
};

export const getFinancingUSDA = async (id, value, cash) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/getBidAmountDetail/${id}/${value}/${cash}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getFinancingUSDA", error);
    throw error;
  }
};
export const getFinancingFHA = async (id, value, cash) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/getBidAmountDetail/${id}/${value}/${cash}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getFinancingFHA", error);
    throw error;
  }
};

export const getFinancingVA = async (id, value, cash) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/getBidAmountDetail/${id}/${value}/${cash}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getFinancingVA", error);
    throw error;
  }
};
export const getautobidAmount = async (id, data) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/getBidAmountDetailWithoutEMD/${id}/${data}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getFinancingVA", error);
    throw error;
  }
};
// !-----This below api is called when the property is for foreclosure
export const getPsoConfigDetails = async (data) => {
  try {
    const response = await baseApi.get(`/portal/getPSOConfigDetails/${data}`);
    return response;
  } catch (error) {
    console.log("Error while fetching getPsoConfigDetails", error);
    throw error;
  }
};

// ! ********************* PLACE BACKUP BID API **************** /////

export const getPlaceBackupBid = async (id, data) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/getAvailableBackUpBidAmount/${id}/${data}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getPlaceBackupBid", error);
    throw error;
  }
};

export const submitBidDepositHold = async (payload) => {
  try {
    const response = await baseApi.post(`/portal/v2.0/submitBid`, payload);
    return response;
  } catch (error) {
    console.log("Error while fetching submitBidDepositHold", error);
    throw error;
  }
};

// ! *********** Place Best Bid *********** ////////

export const getBestBid = async (id) => {
  try {
    const response = await baseApi.get(
      `/portal/isBestBidAvailable?listingId=${id}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getBestBid", error);
    throw error;
  }
};

export const getBuyerBidsCountered = async (id) => {
  try {
    const response = await baseApi.get(
      `/portal/getBuyerBidsCountered?listingId=${id}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getBuyerBidsCountered", error);
    throw error;
  }
};

export const getPlaceBestBidDetails = async (payload) => {
  try {
    const response = await baseApi.post(
      `/portal/getPlaceBestBidDetails`,
      payload
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getPlaceBestBidDetails", error);
    throw error;
  }
};

export const getAvailableBackUpBidAmount = async (id, data) => {
  try {
    const response = await baseApi.get(
      `/portal/v2.0/getAvailableBackUpBidAmount/${id}/${data}`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getAvailableBackUpBidAmount", error);
    throw error;
  }
};

export const getCommercialWatchProperty = async (data) => {
  try {
    const response = await baseApi.post(
      `/portal/watchProperty/${data}?notifyType=DAILY&buyerInterestedInCom=Y`
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getAvailableBackUpBidAmount", error);
    throw error;
  }
};
export const getBuyerPremium = async (id, data) => {
  try {
    const response = await baseApi.get(`/portal/buyerPremium/${id}/${data}`);
    return response;
  } catch (error) {
    console.log("Error while fetching getBuyerPremium", error);
    throw error;
  }
};

export const getPreviousBidDetails = async (payload) => {
  try {
    const response = await baseApi.post(
      `/portal/v2.0/getPreviousBidDetail`,
      payload
    );
    return response;
  } catch (error) {
    console.log("Error while fetching getPlaceBestBidDetails", error);
    throw error;
  }
};

export const submitPlaceBestBidResponse = async (payload) => {
  try {
    const response = await baseApi.post(
      `/portal/submitBestBidResponse`,
      payload
    );
    return response;
  } catch (error) {
    console.log("Error while fetching submitBestBidResponse", error);
    throw error;
  }
};
